const dmsServicesData = [
  {
    title: "Custom DMS Development",
    description:
      "Secure, scalable DMS tailored to your document workflows across teams and departments.",
    bullets: [
      "Custom-built DMS aligned with business needs",
      "Advanced search & AI-based auto-tagging",
      "Role-based access & version control",
      "Seamless integration with ERP and CRM systems",
    ],
    minHeight: 420,
  },
  {
    title: "DMS Implementation",
    description:
      "End-to-end deployment on cloud or on-prem with minimal disruption to business.",
    bullets: [
      "End-to-end deployment & configuration",
      "Secure data migration from legacy systems",
      "Integration with third-party business tools",
      "User onboarding & performance optimization",
    ],
    minHeight: 420,
  },
  {
    title: "DMS Consulting",
    description:
      "Strategy-first guidance to align DMS with compliance, security, and business goals.",
    bullets: [
      "Workflow analysis & optimization strategy",
      "Compliance and security assessment",
      "Technology & tool recommendations",
      "Continuous improvement roadmap",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud-Based DMS Solutions",
    description:
      "Highly available, secure cloud DMS with real-time collaboration and scalability.",
    bullets: [
      "Secure cloud hosting with encryption",
      "Real-time document collaboration",
      "Scalable storage options",
      "Automated backups & disaster recovery",
    ],
    minHeight: 420,
  },
  {
    title: "Data Security & Compliance Management",
    description:
      "Enterprise-grade security with robust access controls and auditability.",
    bullets: [
      "Role-based access & encryption",
      "Audit trails & activity logs",
      "GDPR / HIPAA / ISO compliance",
      "Automated policy enforcement",
    ],
    minHeight: 420,
  },
  {
    title: "Workflow Automation",
    description:
      "Rule-based flows that reduce manual effort and accelerate approvals.",
    bullets: [
      "Automated document routing",
      "Approval & review workflows",
      "Notifications & escalation triggers",
      "Time-saving process automation",
    ],
    minHeight: 420,
  },
  {
    title: "Document Digitization & OCR Services",
    description:
      "Convert paper archives into searchable, structured digital repositories.",
    bullets: [
      "High-speed document scanning",
      "OCR-based text recognition",
      "Metadata & auto-tagging setup",
      "Indexing for fast retrieval",
    ],
    minHeight: 420,
  },
  {
    title: "System Integration & API Connectivity",
    description:
      "Connect DMS with ERP, CRM, and productivity suites for a unified experience.",
    bullets: [
      "ERP / CRM / HRM integrations",
      "API-based connectivity",
      "File sync with Google Drive & SharePoint",
      "Real-time data exchange",
    ],
    minHeight: 420,
  },
  {
    title: "Support & Maintenance",
    description:
      "Keep your DMS reliable with proactive monitoring, updates, and expert support.",
    bullets: [
      "24/7 technical support",
      "Regular system health checks",
      "Version upgrades & patching",
      "Performance optimization",
    ],
    minHeight: 420,
  },
];

export const dmsIntegrationCategories = [
  {
    icon: "fa-solid fa-diagram-project",
    title: "Business & ERP",
    examples: ["ERPNext", "SAP", "Zoho", "Odoo"],
    benefit: "Auto-sync invoices, purchase orders, and reports",
  },
  {
    icon: "fa-solid fa-comments",
    title: "Communication",
    examples: ["Slack", "Microsoft Teams", "Zoom"],
    benefit: "Approve or share docs directly in chat",
  },
  {
    icon: "fa-solid fa-cloud",
    title: "Storage & Cloud",
    examples: ["Google Drive", "Dropbox", "SharePoint"],
    benefit: "Two-way file synchronization",
  },
  {
    icon: "fa-solid fa-scale-balanced",
    title: "Finance & Legal",
    examples: ["QuickBooks", "Tally", "DocuSign", "Adobe Sign"],
    benefit: "Automate documentation & e-sign workflows",
  },
  {
    icon: "fa-solid fa-calendar-check",
    title: "Productivity",
    examples: ["Outlook", "Gmail", "Calendar", "Asana"],
    benefit: "Centralized access to files from daily tools",
  },
];

export const dmsIntegrationLogos = [
  { icon: "fa-brands fa-slack", name: "Slack" },
  { icon: "fa-brands fa-microsoft", name: "Teams" },
  { icon: "fa-solid fa-sitemap", name: "ERPNext" },
  { icon: "fa-brands fa-google-drive", name: "Google Drive" },
  { icon: "fa-brands fa-dropbox", name: "Dropbox" },
  { icon: "fa-solid fa-share-nodes", name: "SharePoint" },
  { icon: "fa-solid fa-file-invoice-dollar", name: "QuickBooks" },
  { icon: "fa-solid fa-file-signature", name: "DocuSign" },
  { icon: "fa-solid fa-building", name: "SAP" },
  { icon: "fa-solid fa-cubes", name: "Zoho" },
];

export const dmsLifecycleSteps = [
  {
    no: "01",
    icon: "fa-solid fa-file-arrow-up",
    title: "Capture & Ingest",
    desc: "Upload or scan documents from any device. AI-powered OCR automatically extracts text, classifies content, and applies metadata tags for instant indexing.",
  },
  {
    no: "02",
    icon: "fa-solid fa-shield-halved",
    title: "Organize & Secure",
    desc: "Documents are encrypted, categorized, and stored in a centralized repository. Access is defined by user roles, ensuring total data protection and compliance.",
  },
  {
    no: "03",
    icon: "fa-solid fa-people-arrows",
    title: "Collaborate & Approve",
    desc: "Enable multi-user editing, version tracking, and approval workflows — all managed through automated notifications and audit trails.",
  },
  {
    no: "04",
    icon: "fa-solid fa-magnifying-glass-chart",
    title: "Retrieve & Analyze",
    desc: "Use intelligent search with filters, tags, and contextual AI to locate any document in seconds. Access actionable insights and patterns across document histories.",
  },
  {
    no: "05",
    icon: "fa-solid fa-box-archive",
    title: "Archive & Optimize",
    desc: "Automate retention schedules and archival rules. Maintain compliance with ISO, GDPR, or HIPAA — while optimizing storage and performance.",
  },
];

export default dmsServicesData;
